import {RoleTypeEnum} from "../../core_modules/enums/role-type.enum";
import {RoleAccess} from "../../core_modules/enums/role-access.enum";

export class Role {
  id: number | any;
  version: number | any;
  roleName: string | undefined;
  status: string | undefined;
  roleType: RoleTypeEnum = RoleTypeEnum.MAKER;
  roleAccess: RoleAccess = RoleAccess.OWN;
  authorityLabel: string | undefined;
  signApprovalSheet: boolean = false;
  data: string | undefined;
  code: string | undefined;
}
